import React, { memo } from "react";
import { Card, Button, Row, Col } from "react-bootstrap";
import { Icon } from "@iconify/react";
import * as configuration from "../../config/app-config.js";
import { Link } from "react-router-dom";
import noDoctorImg from "../../images/noDoctor.png";

const DoctorCard = memo(({ doctor }) => (
  <Card className="mb-3 custom-border">
    <Card.Body>
      <div className="d-flex">
        {/* {doctor.image ? ( */}
          <img
          src={ doctor.image ? `${configuration.API_URL}auth/assets/${doctor.image}` : noDoctorImg}
            // src={`${configuration.API_URL}auth/assets/${doctor.image}` }
            alt={doctor.image}
            className="me-3 doctor-profile"
          />
        {/* ) : (
          <Icon
            icon={
              doctor.gender === "FEMALE"
                ? "et:profile-female"
                : "et:profile-male"
            }
            width="150"
            height="200"
            className="me-3"
            style={{ color: "#0D224E" }}
          />
        )} */}
        <div className="w-100">
          <Card.Title className="darkBlue">{doctor.displayName}</Card.Title>
          <Card.Subtitle className="mb-2 sub-darkBlue">
            {doctor.specialityName}
          </Card.Subtitle>
          <div className="d-flex justify-content-between mb-3">
            <div className="img-container">
              {doctor.hospitalLogo && (
                <img
                  variant="top"
                  className="hospital-logo"
                  src={`${configuration.API_URL}auth/assets/${doctor.hospitalLogo}`}
                  alt={`${doctor.hospitalName} Logo`}
                />
              )}
            </div>
            <div>
              <span className="darkBlue distance-span">
                <Icon
                  icon="fluent:location-28-filled"
                  width="23"
                  height="23"
                  // style={{ color: "#0D224E" }}
                />
                {(doctor.distance * 0.621371).toFixed(2)} mi
              </span>
              <Link
                to={`/doctorProfile/${doctor.displayName}?userId=${btoa(
                  doctor.userId
                )}`}
              >
                <Button variant="primary" className="uniteButton">
                  View Profile{" "}
                  <Icon icon="si:arrow-right-fill" width="24" height="24" />
                </Button>
              </Link>
            </div>
          </div>
          <p className="mb-4">{doctor.bio}</p>
          {/* <div className="d-flex flex-sm-row flex-column gap-sm-5 gap-0"> */}
          <Row>
            <Col xs="6">
            <p className="break-all">
              <Icon icon="material-symbols:mail-outline" className="darkBlue" />{" "}
              {doctor.mailId}
            </p>{" "}
            <p className="break-all">
              <Icon icon="ic:outline-phone" className="darkBlue" />{" "}
              {doctor.phoneNo}
            </p>
            </Col>
            <Col xs="6">
            <p className="break-all">
              <Icon
                icon="material-symbols:location-on-outline"
                className="darkBlue"
              />{" "}
              {doctor.address}
            </p>
            </Col>
          </Row>
        </div>
      </div>
    </Card.Body>
  </Card>
));

export default DoctorCard;
